import { getDriftToken } from 'services/tokenService'
import { createAxiosInstance } from 'api/axiosFactory'
import config from 'config'


const axiosInstance = () => {
  const axiosConfig = {
    baseURL: config.FILE_API_URL,
    headers: {'Authorization': `Bearer ${getDriftToken()}`}
  }
  return createAxiosInstance(axiosConfig)
}

const fileToFormData = (file) => {
  const data = new FormData()
  data.append('file', file)
  return data
}

export const uploadFile = (file) => {
  const data = fileToFormData(file)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }

  return axiosInstance().post('/upload', data, config)
    .then(response => response.data.url)
}
